import React, { memo } from 'react';
import './radio-button-group.scss';

type IradioProps = {
  name?: string;
  value?: string;
  className?: string;
  change?: any;
  options?: any;
  classNamecss?: string;
};

const RadioButtonGroup: React.FC<IradioProps> = (props) => {
  const { name, value, className, classNamecss, change, options } = props;

  return (
    <div className={classNamecss}>
      {options.map((item: any, index: any) => {
        const itemValue = item && item.value;
        const isActive = itemValue === value;

        return (
          <div
            key={item.id}
            className={`ui-form-radio ${className} ${
              isActive && !classNamecss ? 'active' : ''
            }`}
            data-testid="radio-button"
          >
            <input
              type="radio"
              className={`ui-radio ${
                isActive ? 'radio-active' : 'radio-inactive'
              }`}
              data-testid="radio"
              id={`${name}-${index}`}
              name={name}
              value={itemValue}
              onClick={() =>
                change({
                  id: name,
                  value: itemValue,
                })
              }
            />
            <label
              htmlFor={`${name}-${index}`}
              className="ui-form-radio__label"
            >
              {item.label}
              <span className="ui-form-radio__label-small-text">
                {item.text}
              </span>
              {item.image && (
                <img
                  src={item.image}
                  className="ui-form-radio__label-image"
                  alt={item.text}
                />
              )}
            </label>
          </div>
        );
      })}
    </div>
  );
};

RadioButtonGroup.defaultProps = {
  value: '',
  name: '',
  className: '',
  change: () => {},
  options: [],
  classNamecss: '',
};

export default memo(RadioButtonGroup);
